import {
  ActionTypes,
  TAppCurrentOrg,
  TAppCurrentOrgAction,
  TAppDataAction,
  TAppState,
} from './types'

function setAppData(payload: TAppState): TAppDataAction {
  return {
    type: ActionTypes.APP_SET_DATA,
    payload,
  }
}

function setAppCurrentOrg(payload: TAppCurrentOrg): TAppCurrentOrgAction {
  return {
    type: ActionTypes.APP_SET_CURRENT_ORG,
    payload,
  }
}

export { setAppData, setAppCurrentOrg }
